<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_WKFL_ID')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_label">
            {{ frame0.workflowId }}
          </div>
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_WKFL_NM')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            ref="workflowName"
            v-model="frame0.workflowName"
            maxlength="25"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDLE')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-module-submodule-select
            ref="module"
            :pageId="pageId"
            :selectedMd="frame0.selectedCode.COD_MDLE"
            :selectedSmd="frame0.selectedCode.COD_SMDLE"
            @submodule-selected="moduleLoaded"
          />
        </div>     
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_PRC_TASK_STNRD_ID')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            v-model="frame0.processTaskStandardId"
            maxlength="99999999"
            :readonly="true"
          />         
          <sui-button
            type="button"
            name="button"
            class="btn_innerTbl_border"
            @click="processTaskIdEdit"
          >
            {{ $t('MSG_BTN_EDIT') }}
          </sui-button>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_USE_YN')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <sui-radio
            v-model="frame0.workflowUseYn"
            value="Y"
          >
            Yes
          </sui-radio>
          <sui-radio
            v-model="frame0.workflowUseYn"
            value="N"
          >
            No
          </sui-radio>
        </div>
      
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_WKFL_CNTN')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-11">
          <textarea
            v-model="frame0.workflowExplanationContent"
            name="name"
            maxlength="500"
          />
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:create="pageId"
        type="button"
        class="comm_btn_border"
        @click="onClickNew"
      >
        {{ $t('MSG_BTN_NEW') }}
      </sui-button>
      <sui-button
        v-permission:delete="pageId"
        type="button"
        class="comm_btn_border"
        @click="onClickDelete"
      >
        {{ $t('MSG_BTN_DEL') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_border_Prime"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
      <sui-button
        v-permission:create="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickConfirm"
      >
        {{ $t('MSG_BTN_REFLECTION') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00003_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
    processTaskStandardIdInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mountedFlag: true,
      frame0: {
        selectedCode: {
          COD_MDLE: { key: '', label: '' },
          COD_SMDLE: { key: '', label: '' },
        },
        workflowId: '',
        workflowName: '',
        workflowUseYn: 'Y',
        workflowExplanationContent: '',
        processTaskStandardId: '',
      },
    };
  },
  computed: {},
  watch: {
    workflowId() {
      if (!utils.isEmpty(this.selectedRowData)) {
        this.setWorkflowData();
        this.ProcessTaskStandardId();
      }
    },
    processTaskStandardIdInfo: {
      deep: true,
      handler() {
        if (!utils.isUndefined(this.processTaskStandardIdInfo.value)
         && !utils.isEmpty(this.processTaskStandardIdInfo.value)) {
          this.frame0.processTaskStandardId = this.processTaskStandardIdInfo.value;
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.selectedRowData)) {
        this.setWorkflowData();
        this.ProcessTaskStandardId();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 저장되지 않은 데이터 확인
     */
    makeSnapshot() {
      const snapshotData = utils.assign({},
        this.frame0,
        {
          moduleCode: this.frame0.selectedCode.COD_MDLE.key,
          subModuleCode: this.frame0.selectedCode.COD_SMDLE.key,
        });

      return snapshotData;
    },
    moduleLoaded() {
      if (this.mountedFlag) {
        this.saveSnapshot(this.makeSnapshot());
        this.mountedFlag = false;
      }
    },
    /**
     * 워크플로우 기본 정보 SET
     */
    setWorkflowData() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.frame0[key].COD_MDLE.key = this.selectedRowData.moduleCode;
          this.frame0[key].COD_SMDLE.key = this.selectedRowData.subModuleCode;
        } else {
          this.frame0[key] = this.selectedRowData[key] || '';
        }
      });
      this.saveSnapshot(this.makeSnapshot());
    },
    /**
     * 업무기준 ID 조회
     */
    ProcessTaskStandardId() {
      http.request(this.pageId, 'DTS_CMR_00031', {
        path: {
          'workflow-id': this.frame0.workflowId,
        },
      }).then(res => {
        const taskIdList = utils.clone(res.data);
        // this.processTaskIdList = utils.clone(res.data);
        this.frame0.processTaskStandardId = utils.join(utils.map(taskIdList, 'processTaskStandardIdItemName'), '|');
        this.saveSnapshot(this.makeSnapshot());
      });
    },
    /**
     * 저장
     */
    onClickSave() {
      const dataParams = {
        workflowId: this.frame0.workflowId,
        workflowName: this.frame0.workflowName,
        workflowUseYn: this.frame0.workflowUseYn,
        workflowExplanationContent: this.frame0.workflowExplanationContent,
        moduleCode: this.frame0.selectedCode.COD_MDLE.key,
        subModuleCode: this.frame0.selectedCode.COD_SMDLE.key,
        processTaskStandardIdSaveList: [],
        processTaskStandardIdDeleteList: [],
      };

      utils.assign(dataParams, this.processTaskStandardIdInfo);

      if (!this.validationCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00027', {
          data: dataParams,
        }).then(res => {
          this.$emit('onClickSearch');
          this.saveSnapshot(this.makeSnapshot());
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
            if (utils.isEmpty(this.frame0.workflowId)) {
              dataParams.workflowId = res.data.msg;
            }
            this.$emit('setWorkflowInfo', dataParams);
          });
        });
      });

      return true;
    },
    /**
     * 신규
     */
    onClickNew() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          // this.$refs.module.reset();
          this.$refs.module.selectMd('CM');
        } else if (utils.isEqual(key, 'workflowUseYn')) {
          this.frame0[key] = 'Y';
        } else {
          this.frame0[key] = '';
        }
      });

      this.oldTextValue = '';

      this.$emit('onClickNew');
    },
    /**
     * 삭제
     */
    onClickDelete() {
      if (utils.isEmpty(utils.trim(this.frame0.workflowId))) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        return false;
      }

      utils.messageBox('confirm', this.$t('MSG_ALT_DO_DELETE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00028', {
          path: {
            'workflow-id': this.frame0.workflowId,
          },
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'));
          this.$emit('onClickSearch');
          this.onClickNew();
        });
      });

      return null;
    },
    /**
     * 반영
     */
    onClickConfirm() {
      if (!this.selectedNodeCheck()) return false;

      http.request(this.pageId, 'DTS_CMR_00049', {
        path: { 'workflow-id': this.frame0.workflowId },
      }).then(res => {
        utils.openTextAreaEditor(this.workflowConfirm, {
          title: '',
          pageInitialData: {
            value: res.data.ruleText,
            readonly: true,
            positiveButtonText: this.$t('MSG_BTN_CFRM'),
          },
        });
        // utils.messageBox('confirm', '', res.data.ruleText.split('\n'), () => {
        //   this.workflowConfirm();
        // });
      });

      return null;
    },
    workflowConfirm(data) {
      // 팝업 return 확인 취소 여부를 return 값이 있는지 없는지로 구분
      if(utils.isEmpty(data)) return;
      
      http.request(this.pageId, 'DTS_CMR_00050', {
        path: { 'workflow-id': this.frame0.workflowId },
      }).then(res => {
        if (utils.isEqual(res.data.resultCode, '0')) {
          utils.messageBox('warning', '', res.data.msg.split('\n'));
          // utils.messageBox('warning', res.data.msg);
        } else {
          utils.messageBox('information', this.$t('MSG_ALT_SUCCESS_RFL'));
        }
      });
    },
    /**
     * 업무기준 ID 편집 팝업 호출
     */
    processTaskIdEdit() {
      this.$emit('popupCall', 'p01');
    },
    /**
     * 워크플로우 선택 여부 확인
     */
    selectedNodeCheck() {
      if (utils.isEmpty(this.frame0.workflowId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_ID'), this.$t('MSG_TXT_WKFL')));
        return false;
      }
      return true;
    },
    /**
     * 입력 체크
     */
    validationCheck() {
      if (utils.isEmpty(utils.trim(this.frame0.workflowName))) {
        // 워크플로우명 입력해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_WKFL_NM')),
          null,
          () => {
            this.$refs.workflowName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_MDLE.key))) {
        // 모듈을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_SMDLE.key))) {
        // 서브모듈을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.processTaskStandardId))) {
        // 업무기준 ID를 입력해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRC_TASK_STNRD_ID')),
          null,
          () => {});
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.workflowUseYn))) {
        // 사용여부를 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_USE_YN')));
        return false;
      }
      return true;
    },
  },
  datasets: [],
};
</script>
<style scoped>
</style>
